import * as React from 'react';
import ProgressBar from "@ramonak/react-progress-bar";
import styles from './MovingProgress.module.scss'

export default function MovingProgress() {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 20));
    }, 700);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className={styles.holder}>
      <ProgressBar completed={progress}
      />
    </div>
  )
}
